import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { IUser, IUsers } from '../interfaces/user';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(private httpClient: HttpClient) {}

  getUsers(url: string, filters: any): Observable<IUsers> {
    return this.httpClient.get<IUsers>(url, {
      headers: { accept: '*/*' },
      params: filters,
    }) as Observable<IUsers>;
  }

  getUserById(url: string): Observable<IUser> {
    return this.httpClient.get<IUser>(url, { headers: { accept: '*/*' },
    }) as Observable<IUser>;
  };

  editUser(url: string, form: any): Observable<IUser> {
    return this.httpClient.patch<IUser>(url, form, {
      headers: { accept: '*/*' },
    }) as Observable<IUser>;
  }

  getUserByUsername(url: string): Observable<IUsers> {
    return this.httpClient.get<IUsers>(url, {
      headers: { accept: '*/*' },
    }) as Observable<IUsers>;
  }
}
